import { useMemo } from "react";

/**
 * Handles:
 * 1. Extract unique grades
 * 2. Get divisions by grade
 * 3. Convert selected state → API format
 * 4. Convert redux format → controlled state format
 */
export const useClassDivision = (reduxClasses = []) => {

  // ✅ Unique Grades
  const uniqueGrades = useMemo(() => {
    return [...new Set(reduxClasses.map(c => c.grade))];
  }, [reduxClasses]);

  // ✅ Get Divisions by Grade
  const getDivisionsByGrade = (grade) => {
    return reduxClasses
      .filter(c => c.grade === grade)
      .map(c => c.division);
  };

  // ✅ Convert Component State → API Format
  const buildApiPayload = (selectedClasses) => {
    return Object.entries(selectedClasses).flatMap(([grade, obj]) =>
      obj.divisions.map(division => ({
        grade,
        division,
      }))
    );
  };

  // ✅ Convert Redux Format → Component State Format
  const buildInitialState = () => {
    return reduxClasses.reduce((acc, item) => {
      if (!acc[item.grade]) {
        acc[item.grade] = { divisions: [] };
      }
      acc[item.grade].divisions.push(item.division);
      return acc;
    }, {});
  };

  return {
    uniqueGrades,
    getDivisionsByGrade,
    buildApiPayload,
    buildInitialState,
  };
};
